/** Display helpers for location QR records from GET /location-qr */

export const getQrName = qr =>
  qr?.name?.trim() || qr?.display_label?.trim() || qr?.qr_id || 'Unnamed QR';

export const getQrLocation = qr => {
  if (qr?.display_label?.trim()) return qr.display_label.trim();

  if (qr?.location_type === 'amenity') {
    return (
      qr.amenity_name?.trim() ||
      qr.name?.trim() ||
      qr.amenity_id ||
      '—'
    );
  }

  if (qr?.location_type === 'block_floor') {
    const block = qr.block_name?.trim() || qr.block_id;
    const floor =
      qr.floor_name?.trim() ||
      (qr.floor_no != null ? `Floor ${qr.floor_no}` : '');
    if (block && floor) return `${block} - ${floor}`;
    if (block) return block;
  }

  const landmark = qr?.landmark?.trim();
  if (landmark) return landmark;

  if (qr?.location_key) return qr.location_key;

  return '—';
};

export const getQrTypeLabel = qr => {
  if (qr?.location_type === 'amenity') return 'Amenity';
  if (qr?.location_type === 'block_floor') return 'Block / floor';
  return 'Location';
};

export const filterQrCodes = (items, searchTerm) => {
  const query = (searchTerm || '').trim().toLowerCase();
  if (!query) return items;

  return items.filter(qr => {
    const name = getQrName(qr).toLowerCase();
    const location = getQrLocation(qr).toLowerCase();
    const id = (qr?.qr_id || '').toLowerCase();
    const key = (qr?.location_key || '').toLowerCase();
    return (
      name.includes(query) ||
      location.includes(query) ||
      id.includes(query) ||
      key.includes(query)
    );
  });
};
